// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8927) return "static/chunks/8927-02de46168fe1356a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4106 ? "b9633c63" : chunkId) + "." + {"1269":"c97426b17a504135","1638":"58ee124db0fb55c5","1970":"d0ffb4ecb6ab76f5","4106":"60420a8ad16cdc9a","7797":"8426ef137f94bab4","8056":"2f558896cbef5493"}[chunkId] + ".js";
};